export default "__VITE_ASSET__I70uokht__"